<template>
  <div id="contenedor-opciones-tool-bar-contrato-consultas">
    <v-tabs>
      <template
        v-for="(opcion, index) in opciones">
        <template>
          <v-tab
            :key="`opcion-${index}`"
            :to="{ name: opcion.ruta }"
            exact>
            {{ opcion.nombre }}
          </v-tab>
        </template>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBarContratoConsultas',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'consultasContratoDefault',
          icono: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'consultasContratoAnticipos',
          icono: '',
        },
        {
          nombre: 'Convenios mod.',
          ruta: 'consultasContratoConveniosModificatorios',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'consultasContratoPrograma',
          icono: '',
        },
        {
          nombre: 'Catálogo',
          ruta: 'consultasContratoCatalogo',
          icono: '',
        },
        {
          nombre: 'Reportes',
          ruta: 'consultasContratoEjecucionReportes',
          icono: '',
        },
        {
          nombre: 'Estimaciones',
          ruta: 'consultasContratoEjecucionEstimaciones',
          icono: '',
        },
        {
          nombre: 'Album Fotográfico',
          ruta: 'consultasContratoAlbum',
          icono: '',
        },
        {
          nombre: 'Videos',
          ruta: 'consultaContratoVideos',
          icono: '',
        },
        {
          nombre: 'Fianzas',
          ruta: 'consultasContratoFianzas',
          icono: '',
        },
        {
          nombre: 'Actividades',
          ruta: 'consultasContratoActividades',
          icono: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'consultasContratoExpediente',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
